import { render } from "./TccView.vue?vue&type=template&id=81af6470&scoped=true"
import script from "./TccView.vue?vue&type=script&lang=js"
export * from "./TccView.vue?vue&type=script&lang=js"

import "./TccView.vue?vue&type=style&index=0&id=81af6470&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81af6470"]])

export default __exports__